import { Injectable } from '@angular/core';
import { ModalComponent } from './../shared/components/modal/modal.component';


@Injectable({ providedIn: 'root' })
export class ModalService {
    private modals: ModalComponent[] = [];

    add(modal: ModalComponent) {      
        // ensure component has a unique id attribute
        if (!modal.id || this.modals.find(x => x.id === modal.id)) {
            throw new Error('ATENCION! Modal debe tener un atributo de identificación único!');
        }
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(modal: ModalComponent) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x === modal);
    }

    close() {
        // close the modal that is currently open
        const modal = this.modals.find(x => x.isOpen);
        modal?.close();
    }

    open(id: string) {
        // open modal specified by id
        const modal = this.modals.find(x => x.id === id);
        if (!modal) {
            throw new Error(`modal '${id}' not found`);
        }
        modal.open();
    }

    closeId(id: string) {
        const modal = this.modals.find(x => x.id === id);
        if (!modal) {
            throw new Error(`modal '${id}' not found`);
        }
        modal?.close();
    }

    openObservador(id: string) {
        // open modal specified by id
        const modal = this.modals.find(x => x.id === id);
        if (!modal) {
            window.location.reload();
        }
        modal.open();         
    }

}